// Data file for Pet Breed Matcher
// Contains dog and cat breed data and quiz questions

// Dog and cat breed data will be loaded from JSON files
let dogBreeds = [];
let catBreeds = [];

// Quiz questions structure
const quizQuestions = {
  // Initial pet type selection
  petType: {
    id: 'petType',
    text: 'Are you looking for a dog or a cat?',
    type: 'petType',
    options: [
      { value: 'dog', text: 'Dog' },
      { value: 'cat', text: 'Cat' }
    ]
  },
  
  // Common questions for both dogs and cats
  common: [
    {
      id: 'livingSpace',
      text: 'What type of home do you live in?',
      type: 'option',
      options: [
        { value: 'apartment-no-yard', text: 'Apartment without outdoor space' },
        { value: 'apartment-small-yard', text: 'Apartment/house with small outdoor space' },
        { value: 'house-medium-yard', text: 'House with medium-sized yard' },
        { value: 'house-large-yard', text: 'House with large yard/property' }
      ]
    },
    {
      id: 'timeAtHome',
      text: 'How much time will someone be at home with your pet?',
      type: 'option',
      options: [
        { value: 'most-of-time', text: 'Someone will be home most of the time' },
        { value: 'part-of-day', text: 'Home for part of the day (4-8 hours away)' },
        { value: 'long-periods', text: 'Away for long periods (8+ hours daily)' }
      ]
    },
    {
      id: 'children',
      text: 'Do you have children in your home?',
      type: 'option',
      options: [
        { value: 'no-children', text: 'No children' },
        { value: 'older-children', text: 'Older children (8+ years)' },
        { value: 'young-children', text: 'Young children (under 8 years)' },
        { value: 'planning-children', text: 'Planning to have children soon' }
      ]
    },
    {
      id: 'otherPets',
      text: 'Do you have other pets?',
      type: 'option',
      options: [
        { value: 'no-other-pets', text: 'No other pets' },
        { value: 'dogs-cats', text: 'Other dogs/cats' },
        { value: 'small-pets', text: 'Small pets (birds, hamsters, etc.)' },
        { value: 'various-pets', text: 'Various pets' }
      ]
    },
    {
      id: 'grooming',
      text: 'How much time can you commit to grooming your pet?',
      type: 'option',
      options: [
        { value: 'minimal', text: 'Minimal grooming (quick brush once a week)' },
        { value: 'moderate', text: 'Moderate grooming (regular brushing)' },
        { value: 'high', text: 'High maintenance (daily brushing, regular professional grooming)' }
      ]
    },
    {
      id: 'shedding',
      text: 'What is your tolerance for pet hair/shedding?',
      type: 'option',
      options: [
        { value: 'minimal', text: 'I prefer minimal shedding' },
        { value: 'moderate', text: 'Some shedding is okay' },
        { value: 'any-shedding', text: 'I don\'t mind shedding at all' }
      ]
    },
    {
      id: 'activityLevel',
      text: 'What is your activity level?',
      type: 'option',
      options: [
        { value: 'sedentary', text: 'Sedentary (minimal exercise)' },
        { value: 'moderately-active', text: 'Moderately active (short daily walks/play)' },
        { value: 'active', text: 'Active (longer daily exercise sessions)' },
        { value: 'very-active', text: 'Very active (extensive exercise, outdoor activities)' }
      ]
    }
  ],
  
  // Dog-specific questions
  dog: [
    {
      id: 'size',
      text: 'What size dog would you prefer?',
      type: 'option',
      options: [
        { value: 'small', text: 'Small (under 20 pounds)' },
        { value: 'medium', text: 'Medium (20-50 pounds)' },
        { value: 'large', text: 'Large (50-90 pounds)' },
        { value: 'giant', text: 'Giant (90+ pounds)' },
        { value: 'no-preference', text: 'No preference' }
      ]
    },
    {
      id: 'training',
      text: 'How much time can you commit to training your dog?',
      type: 'option',
      options: [
        { value: 'basic', text: 'Basic training only' },
        { value: 'regular', text: 'Regular training sessions' },
        { value: 'extensive', text: 'Extensive training and mental stimulation' },
        { value: 'professional', text: 'Professional training assistance' }
      ]
    },
    {
      id: 'barking',
      text: 'What is your tolerance for barking?',
      type: 'option',
      options: [
        { value: 'quiet', text: 'Prefer a quiet dog' },
        { value: 'occasional', text: 'Occasional barking is okay' },
        { value: 'any-barking', text: 'Don\'t mind barking' }
      ]
    },
    {
      id: 'purpose',
      text: 'What is the main purpose for getting a dog?',
      type: 'option',
      options: [
        { value: 'companionship', text: 'Companionship' },
        { value: 'family', text: 'Family pet' },
        { value: 'protection', text: 'Protection/guard dog' },
        { value: 'active', text: 'Active companion for sports/activities' }
      ]
    }
  ],
  
  // Cat-specific questions
  cat: [
    {
      id: 'personality',
      text: 'What type of cat personality do you prefer?',
      type: 'option',
      options: [
        { value: 'independent', text: 'Independent and low-maintenance' },
        { value: 'balanced', text: 'Balanced between affectionate and independent' },
        { value: 'affectionate', text: 'Very affectionate and people-oriented' },
        { value: 'playful', text: 'Playful and energetic' }
      ]
    },
    {
      id: 'vocalization',
      text: 'What is your preference for cat vocalization?',
      type: 'option',
      options: [
        { value: 'quiet', text: 'Prefer a quiet cat' },
        { value: 'moderate', text: 'Moderate vocalization is fine' },
        { value: 'talkative', text: 'Enjoy a talkative cat' }
      ]
    },
    {
      id: 'indoorOutdoor',
      text: 'Will your cat be indoor, outdoor, or both?',
      type: 'option',
      options: [
        { value: 'indoor', text: 'Strictly indoor' },
        { value: 'mostly-indoor', text: 'Mostly indoor with supervised outdoor time' },
        { value: 'indoor-outdoor', text: 'Indoor/outdoor mix' },
        { value: 'mostly-outdoor', text: 'Mostly outdoor' }
      ]
    }
  ]
};

// Load breed data from JSON files
// async function loadBreedData() {
//   try {
//     // Load dog breeds
//     const dogResponse = await  fetch('{{ 'dog_breeds.json' | asset_url }}');
//     const dogData = await dogResponse.json();
//     dogBreeds = dogData.breeds;
    
//     // Load cat breeds
//     const catResponse = await fetch('{{ 'cat_breeds.json' | asset_url }}');
//     const catData = await catResponse.json();
//     catBreeds = catData.breeds;
    
//     console.log('Breed data loaded successfully');
//     return true;
//   } catch (error) {
//     console.error('Error loading breed data:', error);
//     return false;
//   }
// }

async function loadBreedData() {
  try {
    const dogResponse = await fetch(window.breedDataUrls.dog);
    const dogData = await dogResponse.json();
    dogBreeds = dogData.breeds;

    const catResponse = await fetch(window.breedDataUrls.cat);
    const catData = await catResponse.json();
    catBreeds = catData.breeds;

    console.log('Breed data loaded successfully');
    return true;
  } catch (error) {
    console.error('Error loading breed data:', error);
    return false;
  }
}



// Export data for use in other scripts
export { dogBreeds, catBreeds, quizQuestions, loadBreedData };
